import React, { useState } from "react";
import { COLORS, FONT_BODY, FONT_DISPLAY, FONT_MONO } from "../theme.js";
import { MATERIAL_TIPS } from "../domain/materials.js";

const HUB_TOPICS = [
  { key: "leather", title: "Leather Care", sub: "Keep leather looking premium", tips: [MATERIAL_TIPS.Leather, MATERIAL_TIPS["Patent Leather"], MATERIAL_TIPS["Saffiano Leather"]] },
  { key: "suede", title: "Suede & Nubuck Care", sub: "Protect delicate materials", tips: [MATERIAL_TIPS.Suede, MATERIAL_TIPS.Nubuck, MATERIAL_TIPS.Lambskin] },
  { key: "sole", title: "Sole Care", sub: "Outsole & midsole maintenance", tips: [MATERIAL_TIPS["Gum Rubber"], MATERIAL_TIPS.Boost, MATERIAL_TIPS.Phylon] },
  { key: "hardware", title: "Hardware & Closures", sub: "Bags, purses & wallets", tips: [MATERIAL_TIPS["Gold-Tone"], MATERIAL_TIPS["Silver-Tone"], MATERIAL_TIPS.Zipper, MATERIAL_TIPS["Turn-Lock"]] },
  {
    key: "shape",
    title: "Shape & Structure",
    sub: "Preventing sag and creasing",
    tips: [
      "Store handbags stuffed with acid-free paper or a purse pillow — never newspaper, which transfers ink.",
      "Never hang a bag by its handles long-term; the weight stretches and distorts them.",
      "Avoid overfilling wallets — permanent card-slot stretching is the most common failure.",
    ],
  },
  {
    key: "storage",
    title: "Storage Guide",
    sub: "Best practices for storage",
    tips: ["Store at 65-72°F (18-22°C) with 45-55% humidity.", "Keep boxes off direct-sunlight shelving to slow UV yellowing."],
  },
  {
    key: "humidity",
    title: "Humidity & Temperature",
    sub: "Ideal conditions for longevity",
    tips: ["Avoid garages and attics — swings in temperature accelerate glue aging.", "Silica packets in storage bins help control moisture."],
  },
  {
    key: "restoration",
    title: "Restoration Directory",
    sub: "Trusted experts near you",
    tips: ["Look for restorers specializing in your upper material.", "Always ask for before/after samples before committing a grail pair."],
  },
  {
    key: "products",
    title: "Preservation Products",
    sub: "Recommended products",
    tips: ["A soft-bristle suede brush and a pH-neutral leather cleaner cover most collections.", "Silicone-based protectant sprays work across most synthetic uppers."],
  },
];

export default function PreservationHub() {
  const [open, setOpen] = useState(null);

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 18 }}>
      <span style={{ fontFamily: FONT_DISPLAY, fontSize: 20, color: COLORS.cream }}>Preservation Hub</span>
      <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
        {HUB_TOPICS.map((t) => (
          <div
            key={t.key}
            style={{ background: COLORS.blackCard, border: `1px solid ${COLORS.lineFaint}`, borderRadius: 14, padding: 16, cursor: "pointer" }}
            onClick={() => setOpen(open === t.key ? null : t.key)}
          >
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
              <div>
                <div style={{ fontFamily: FONT_DISPLAY, fontSize: 15.5, color: COLORS.cream }}>{t.title}</div>
                <div style={{ fontSize: 11.5, color: COLORS.creamFaint, fontFamily: FONT_BODY, marginTop: 2 }}>{t.sub}</div>
              </div>
              <span style={{ color: COLORS.goldBright, fontFamily: FONT_MONO }}>{open === t.key ? "−" : "+"}</span>
            </div>
            {open === t.key && (
              <div style={{ marginTop: 12, display: "flex", flexDirection: "column", gap: 6 }}>
                {t.tips.map((tip, i) => (
                  <div key={i} style={{ fontSize: 12.5, color: COLORS.creamDim, fontFamily: FONT_BODY }}>
                    • {tip}
                  </div>
                ))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
}
